import React, { Component } from 'react';
import styled from 'styled-components';
import Pose from './Pose';
import { connect } from 'react-redux';

const Container = styled.div`
  border-radius: 5px;
  background-color: ${props => props.color};
  width: 100%;
  margin: auto;
  height: auto;
  display: block;
  margin-top: 30px;
  padding-bottom: 10px;
`

const ContentContainer = styled.div`
  margin: auto;
  width: 90%;
  padding-top: 10px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
`

const Title = styled.h5`
  border-radius: 5px 5px 0px 0px;
  color: white;
  font-size: 1.2em;
  background-color: rgba(0, 0, 0, 0.08);
  text-align: center;
  width: 100%;
  margin: auto;
  padding-top: 3px;
  margin-bottom: 0px;
  height: 26px;
  display: block;
`

class Section extends Component {

  renderPoses = () => {
    const { sectionIdentifier, poseIdentifiers } = this.props
    return poseIdentifiers.map((poseIdentifier, index) =>
      <Pose poseIdentifier={poseIdentifiers[index]} indexPath={sectionIdentifier + "-" + index} key={index}/>
    );
  }

  render() {
    return (
      <div>
        <Container color={this.props.color}>
          <Title>{this.props.name}</Title>
          <ContentContainer>
            { this.renderPoses() }
          </ContentContainer>
        </Container>
      </div>
    );
  }

}

export default connect()(Section);



// WEBPACK FOOTER //
// ./src/Section.js